import { render, staticRenderFns } from "./RepEveningStatsWidget.vue?vue&type=template&id=2a41ff9c"
import script from "./RepEveningStatsWidget.vue?vue&type=script&lang=ts"
export * from "./RepEveningStatsWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports